import { render } from "./Detail.vue?vue&type=template&id=0d3f80f3&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"

import "./Detail.vue?vue&type=style&index=0&id=0d3f80f3&scoped=true&lang=css"
import "./Detail.vue?vue&type=style&index=1&id=0d3f80f3&lang=css"

import exportComponent from "/codebuild/output/src3012/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d3f80f3"]])

export default __exports__